import { useMemo } from "react";
import { useTranslation } from "react-i18next";

export const ncsColorPickerK = {
  dialogTitle: "ncs_color_picker.dialogTitle",
  hueGroupYellow: "ncs_color_picker.hueGroupYellow",
  hueGroupBlue: "ncs_color_picker.hueGroupBlue",
  hueGroupNeutral: "ncs_color_picker.hueGroupNeutral",
  searchPlaceholder: "ncs_color_picker.searchPlaceholder",
  noResultsFound: "ncs_color_picker.noResultsFound",
  hueGroupGreen: "ncs_color_picker.hueGroupGreen",
  noColorSelected: "ncs_color_picker.noColorSelected",
  hueGroupRed: "ncs_color_picker.hueGroupRed",
  recentColors: "ncs_color_picker.recentColors",
};

export const useNcsColorPickerT = () => {
  const { t, i18n } = useTranslation();
  
  return useMemo(
    () => ({
      dialogTitle: t(ncsColorPickerK.dialogTitle),
      hueGroupYellow: t(ncsColorPickerK.hueGroupYellow),
      hueGroupBlue: t(ncsColorPickerK.hueGroupBlue),
      hueGroupNeutral: t(ncsColorPickerK.hueGroupNeutral),
      searchPlaceholder: t(ncsColorPickerK.searchPlaceholder),
      noResultsFound: t(ncsColorPickerK.noResultsFound),
      hueGroupGreen: t(ncsColorPickerK.hueGroupGreen),
      noColorSelected: t(ncsColorPickerK.noColorSelected),
      hueGroupRed: t(ncsColorPickerK.hueGroupRed),
      recentColors: t(ncsColorPickerK.recentColors),
    }),
    [i18n.language]
  );
};